import moment from 'moment';

export const BR_DATE_FORMAT = 'DD/MM/YYYY';
export const BR_DATE_TIME_FORMAT = 'DD/MM/YYYY - HH:mm:ss';

export const US_DATE_FORMAT = 'YYYY-MM-DD';
export const US_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const getISOFromDate = (date: string) => {
  if (!date) {
    return null;
  }
  return moment(date, 'DD/MM/YYYY').toISOString();
};
